<template>
    <section class="approvalResultDenied">
        <v-container class="nav">
            <v-card-title>
                <v-row align="center">
                    <v-col
                        cols="2"
                        sm="2"
                        lg="1"
                        class="pr-0"
                        align="right"
                    >
                        <v-avatar class="page-icon_result teal mr-2 elevation-5">
                            <v-icon large class="white--text">
                                {{ mdiPaperclip }}
                            </v-icon>
                        </v-avatar>
                    </v-col>
                    <v-col
                        cols="10"
                        sm="10"
                        lg="11"
                        class="pl-0"
                    >
                        <h2 style="word-break: normal;">
                            Out-Patient Procedure Approval Result
                        </h2>
                    </v-col>
                </v-row>
            </v-card-title>
            <v-divider />
        </v-container>
        <v-container v-if=" getOppaResult.OPPAN_NO" :style="`padding: ${screen_width > 959 ? '0 30px' : '0'}; margin-bottom: ${screen_width > 959 ? '30px' : '0'}`">
            <v-card :style="`padding: ${screen_width > 959 ? '20px' : screen_width > 599 ? '20px' : '20px 0'};`">
                <v-card :style="`background-color: #F9F9F9; padding-bottom: ${screen_width > 959 ? '20px' : screen_width > 599 ? '20px' : '0'}`">
                    <div :style="`padding: ${screen_width > 959 ? '10px 20px 1px 20px' : screen_width > 599 ? '10px 20px 0 20px' : '0 20px'}`">
                        <p style="font-size: 19px; font-weight: 600;">
                            THIS REQUEST WAS DENIED
                        </p>
                        <p>Your request for out-patient consultation on {{ getOppaResult.HOSP_NAME }} <span v-if="getOppaResult.DOCTOR || (getOppaResult.DOCTOR).trim() != ''">- DR. {{ getOppaResult.DOCTOR }}</span> was denied due to the following reason:</p>
                    </div>
                    <v-alert
                        text
                        color="#777"
                        :style="`margin: ${screen_width > 959 ? '0 20px' : screen_width > 599 ? '0 20px' : '0'}; border-left: 8px solid gray;`"
                    >
                        <span style="color: black;">{{ getOppaResult.ERROR }}</span>
                    </v-alert>
                    <p
                        v-if="getOppaResult && getOppaResult.AR"
                        :style="`text-align: right; margin: ${screen_width > 959 ? '10px 17px 15px 0' : '10px 10px 0 10px'}; padding: ${screen_width > 599 ? '0' : '0 0 20px 0'}`"
                    >
                        <v-btn
                            x-small
                            :style="`text-align: right; margin: ${screen_width > 959 ? '0 0 15px 0' : '10px 10px 0 10px'}`"
                            @click="showAr = !showAr"
                        >
                            <v-icon small>
                                {{ mdiFileDocument }}
                            </v-icon>{{ showAr ? 'Hide' : 'View' }} Details
                        </v-btn>
                    </p>
                </v-card>
                <v-expand-transition>
                    <v-card
                        v-if="getOppaResult && getOppaResult.AR && showAr"
                        style="padding: 0; margin-top: 20px; background-color: #F9F9F9;"
                    >
                        <v-data-table
                            :headers="header"
                            :items="computedData"
                            :items-per-page="-1"
                            no-data-text
                            class="approvalResultDeniedArTbl elevation-2"
                            hide-default-footer
                            :single-expand="false"
                            show-expand
                            item-key="uniqueKey"
                            :expanded.sync="expanded"
                        >
                            <template #top>
                                <p style="margin: 0 0 0 15px; padding-top: 10px; font-size: 18px;">
                                    Outstanding Hospital Bill
                                </p>
                            </template>
                            <template #[`item.DMDA_D`]="{ item }">
                                <p style="text-wrap: nowrap; padding-top: 15px;">
                                    {{ item.DMDA_D }}
                                </p>
                            </template>
                            <template #[`expanded-item`]="{ headers, item }">
                                <td :colspan="headers.length">
                                    <b>REMARKS:</b> {{ item.REMA_M }}
                                </td>
                            </template>
                            <template
                                v-if="!$vuetify.breakpoint.xs"
                                #[`body.append`]
                            >
                                <tr>
                                    <td style="font-weight: 600;">
                                        TOTAL
                                    </td>
                                    <td>-</td>
                                    <td style="font-weight: 600; text-align: right; text-wrap: nowrap;">
                                        {{ getOppaResult.AR.EHB }}
                                    </td>
                                    <td style="text-align: right;">
                                        -
                                    </td>
                                    <td style="font-weight: 600; text-align: right; text-wrap: nowrap">
                                        {{ getOppaResult.AR.PH }}
                                    </td>
                                    <td style="text-align: right;">
                                        -
                                    </td>
                                    <td></td>
                                </tr>
                            </template>
                        </v-data-table>
                        <v-row
                            v-if="screen_width < 599"
                            :style="`margin: ${screen_width > 959 ? '10px 7px' : screen_width > 599 ? '7px' : '7px'};`"
                        >
                            <v-col cols="12" sm="6">
                                <span style="display: block; color: #555;">Total Excess Hospital Bill (EHB):</span><b>{{ getOppaResult.AR.EHB }}</b>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <span style="display: block; color: #555;">Total PhilHealth (PH):</span><b>{{ getOppaResult.AR.PH }}</b>
                            </v-col>
                        </v-row>
                        <v-alert
                            style="margin: 0; padding-top: 10px;"
                            dense
                            text
                            type="warning"
                            class="mt-3"
                            color="#C87100"
                            :icon="mdiAlertCircleCheckOutline"
                        >
                            <strong>You have an unpaid balance of <span class="danger">{{ getOppaResult.AR.TOTAL }}</span> (excluding interests).</strong>
                        </v-alert>
                    </v-card>
                </v-expand-transition>
                <v-row :style="`margin: ${screen_width > 959 ? '10px 7px' : screen_width > 599 ? '7px' : '10px 7px'};`">
                    <v-col cols="12" sm="6">
                        <span style="display: block; color: #555;">APPROVAL NUMBER:</span><b>Not Available</b>
                    </v-col>
                    <v-col cols="12" sm="6">
                        <span style="display: block; color: #555;">Status:</span><b style="color: red;">{{ getOppaResult.APPROVED ? 'APPROVED' : 'DISAPPROVED' }}</b>
                    </v-col>
                </v-row>
                <v-card :style="`padding: ${screen_width > 959 ? '0 17px' : screen_width > 599 ? '17px' : '0 17px'}; background-color: #F9F9F9;`">
                    <v-row>
                        <v-col cols="12" sm="6">
                            <div>
                                <span style="display: block; color: #555;">Medical Provider:</span><b>{{ getOppaResult.HOSP_NAME }}</b>
                            </div>
                            <div class="mt-4">
                                <span style="display: block; color: #555;">Specialist:</span><span v-if="getOppaResult.DOCTOR || (getOppaResult.DOCTOR).trim() != ''"><b>DR. {{ getOppaResult.DOCTOR }}</b></span><span v-else><b>Any HMI Affiliated Doctor</b></span>
                            </div>
                        </v-col>
                        <v-col cols="12" sm="6">
                            <v-divider class="d-sm-none my-3" />
                            <div>
                                <span style="display: block; color: #555;">Patient Name:</span><b>{{ getOppaResult.NAME }}</b>
                            </div>
                            <div class="mt-4">
                                <span style="display: block; color: #555;">Date of Birth:</span><b>{{ getOppaResult.DOB }}</b>
                            </div>
                        </v-col>
                    </v-row>
                </v-card>
                <v-container style="text-align: center; margin-top: 10px;">
                    <v-btn
                        style="margin: 20px auto;"
                        @click="goBack()"
                    >
                        <h1>Done</h1>
                    </v-btn>
                    <h1 style="color: #00BA94;">
                        Should you need assistance, kindly contact <a style="color: #00BA94" href="https://www.hmi.com.ph/contact">HMI</a>.
                    </h1>
                </v-container>
            </v-card>
        </v-container>
    </section>
</template>
<script>
import { mapGetters } from 'vuex'
import { moment } from '../../../utils/date-shim'
import { mdiAlertCircleCheckOutline, mdiFileDocument, mdiPaperclip } from '@mdi/js'
export default {
    data: () => {
        return ({
            mdiAlertCircleCheckOutline, mdiFileDocument, mdiPaperclip,
            expanded: [],
            showAr: false,
            opan_n: '',
            screen_width: document.documentElement.clientWidth + 9,
            footer_props: {
                'items-per-page-options': []
            },
            header: [
                { text: 'Debit Memo No.', value: 'DMNO_N', align: 'start', class: 'teal--text' },
                { text: 'Date', value: 'DMDA_D', align: 'start', class: 'teal--text' },
                { text: 'EHB', value: 'DUEH_A', align: 'end', class: 'teal--text' },
                { text: 'Paid EHB', value: 'PAEH_A', align: 'end', class: 'teal--text' },
                { text: 'PH', value: 'DUME_A', align: 'end', class: 'teal--text' },
                { text: 'Paid PH', value: 'PAME_A', align: 'end', class: 'teal--text' },
                { text: 'Remarks', value: 'data-table-expand', class: 'teal--text' }
            ]
        })
    },
    computed: {
        ...mapGetters(['getOppaResult']),
        computedData() {
            return this.getData.map((item, index) => ({
                ...item,
                uniqueKey: `${item.DMNO_N || 'row'}-${index}` // Ensures uniqueness
            }))
        },
        getData: {
            get(){
                let row = this.getOppaResult.AR.ROW
                let data = []
                if (row) {
                    for (var i = 0; i < row.length; i++) {
                        data.push({
                            DMNO_N: row[i].DMNO_N,
                            DMDA_D: moment(row[i].DMDA_D).utcOffset('+0800').format('YYYY-MM-DD'),
                            DUEH_A: (row[i].DUEH_A) ? (row[i].DUEH_A).toFixed(2) : '0.00',
                            DUME_A: (row[i].DUME_A) ? (row[i].DUME_A).toFixed(2) : '0.00',
                            PAEH_A: (row[i].PAEH_A) ? (row[i].PAEH_A).toFixed(2) : '0.00',
                            PAME_A: (row[i].PAME_A) ? (row[i].PAME_A).toFixed(2) : '0.00',
                            REMA_M: row[i].REMA_M
                        })
                    }
                }
                return data
            }
        }
    },
    mounted() {
        window.addEventListener('resize', this.onResize)
    },
    destroyed() {
        window.removeEventListener('resize', this.onResize)
    },
    created () {
        this.opan_n = this.$route.query.OPPAN
    },
    methods: {
        onResize() {
            this.screen_width = document.documentElement.clientWidth
        },
        goBack() {
            this.$router.push('/dashboard/consultation')
        }
    }
}
</script>

<style>
.approvalResultDeniedArTbl tbody tr:nth-child(odd){
    background-color: #eee;
}
.approvalResultDeniedArTbl div table thead tr th {
    text-wrap: nowrap; text-align: left !important;
}
.approvalResultDenied {
  width: 100%;
  background-image: url("../../../assets/dashboardBG.webp");
  background-position: center;
  background-size: cover;
}
@media (max-width: 390px) {
  .page-icon_result {
    display: none;
  }
}
h1 {
    font-size: 18px;
}
@media (max-width: 599px) {
  /* Navbar */
  .approvalResultDenied .nav {
    margin-top: 60px;
  }
  .approvalResultDenied .nav h2 {
    font-size: 25px;
  }
}
@media (min-width: 599px) and (max-width: 968px) {
  /* Navbar */
  .approvalResultDenied .nav {
    margin-top: 60px;
  }
  .approvalResultDenied .nav h2 {
    font-size: 25px;
  }
}
@media (min-width: 968px) and (max-width: 1264px) {
  /* Navbar */
  .approvalResultDenied .nav {
    margin-top: 60px;
  }
  .approvalResultDenied .nav h2 {
    font-size: 25px;
  }
}
</style>
